import React, { useRef } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ScrollContainer from "components/basic/scrollContainer";
import useOffsetTop from "hooks/useOffsetTop";

interface SignUpReviewLayoutProps {
  children: React.ReactNode;
  maxWidth: number;
}

const SignUpReviewLayout: React.FC<SignUpReviewLayoutProps> = ({
  children,
  maxWidth,
}) => {
  const theme = useTheme();
  // Phones scroll the page itself rather than a fixed-height inner region.
  const isCompact = useMediaQuery(theme.breakpoints.down("md"));
  const rootRef = useRef<HTMLDivElement>(null);
  const offsetTop = useOffsetTop(rootRef);

  const content = (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        px: 2,
        py: { xs: 3, md: 4 },
      }}
    >
      <Box sx={{ width: "100%", maxWidth }}>{children}</Box>
    </Box>
  );

  return (
    <div ref={rootRef}>
      {isCompact ? (
        content
      ) : (
        <ScrollContainer height={`calc(100dvh - ${offsetTop}px)`}>
          {content}
        </ScrollContainer>
      )}
    </div>
  );
};

export default SignUpReviewLayout;
